import React from "react";

import TeamMembers from "./TeamMembers";
import Advisors from "./Advisors";

import ButtonSection from "../../components/ButtonSection/ButtonSection";
import ReadAloud from "../../components/ReadAloud/ReadAloud";

const Attributions = ({ fontSize }) => {
  const sections = {
    "Team Members": (
      <div>
        <TeamMembers fontSize={fontSize} />
      </div>
    ),
    Advisors: (
      <div>
        <Advisors fontSize={fontSize} />
        <div style={{ marginTop: "3vh", marginBottom: "5vh" }}>
          <ReadAloud fontSize={`${25 + fontSize}px`}>
            Special thanks to Dr. Todd Holyoak, Dr. Bernard Duncker, Dr. Valerie
            Ward, Dr. Barbara Moffatt, Dr. Trevor Charles and Dr. Brian Ingalls
            for supplying us with lab materials!
          </ReadAloud>
        </div>
        <h2 style={{ fontSize: `${30 + fontSize}px`, color: "var(--logo)" }}>
          University of Waterloo PhD Students or Post-Docs
        </h2>
        <ReadAloud fontSize={`${16 + fontSize}px`}>
          <h4 style={{ fontSize: `${20 + fontSize}px` }} className="page-name">
            Abigail Conner
          </h4>
          <ul className="page-text">
            <li>Assessed feasibility in project selection process</li>
            <li>
              Provided project feedback at various times throughout the year
            </li>
          </ul>
        </ReadAloud>

        <ReadAloud fontSize={`${16 + fontSize}px`}>
          <h4 style={{ fontSize: `${20 + fontSize}px` }} className="page-name">
            Atiyeh Ahmadi
          </h4>
          <ul className="page-text">
            <li>Prepared the materials for lab training</li>
            <li>Helped train the team in specific microbiology procedures</li>
          </ul>
        </ReadAloud>

        <ReadAloud fontSize={`${16 + fontSize}px`}>
          <h4 style={{ fontSize: `${20 + fontSize}px` }} className="page-name">
            Mike Meleka
          </h4>
          <ul className="page-text">
            <li>Provided advice for plasmid construction</li>
          </ul>
        </ReadAloud>

        <ReadAloud fontSize={`${16 + fontSize}px`}>
          <h4 style={{ fontSize: `${20 + fontSize}px` }} className="page-name">
            Rebecca Quinn
          </h4>
          <ul className="page-text">
            <li>Provided advice for plasmid construction</li>
          </ul>
        </ReadAloud>

        <ReadAloud fontSize={`${16 + fontSize}px`}>
          <h4 style={{ fontSize: `${20 + fontSize}px` }} className="page-name">
            Dr. Reza Roushan
          </h4>
          <ul className="page-text">
            <li>Provided wet lab training</li>
            <li>Helped develop protocols</li>
            <li>
              Guided the team through cannabinoid quantification, Gibson
              assembly troubleshooting, and gel extraction
            </li>
            <li>
              Helped troubleshoot Gibson assembly and transformation procedures
            </li>
          </ul>
        </ReadAloud>
      </div>
    ),
    Stakeholders: (
      <div>
        <ReadAloud fontSize={`${16 + fontSize}px`}>
          <h4 style={{ fontSize: `${20 + fontSize}px` }} className="page-name">
          Brad Poulos | Professor | Toronto Metropolitan University | Cannabis Business Expert
          </h4>
          <ul className="page-text">
            <li>Provided specific feedback on our project direction</li>
            <li>
              Explained current laws around recreational cannabis use and
              marketing
            </li>
            <li>
              Fleshed out the problems in the recreational cannabis industry
            </li>
          </ul>
        </ReadAloud>
        <ReadAloud fontSize={`${16 + fontSize}px`}>
          <h4 style={{ fontSize: `${20 + fontSize}px` }} className="page-name">
            DumbDutchMen | Cannabis Business
          </h4>
          <ul className="page-text">
            <li>
              Explained the current cannabis cultivation process starting from
              the seed{" "}
            </li>
          </ul>
        </ReadAloud>
        <ReadAloud fontSize={`${16 + fontSize}px`}>
          <h4 style={{ fontSize: `${20 + fontSize}px` }} className="page-name">
            Jeff Tribe | Previous Businessman at Various Cannabis Companies
          </h4>
          <ul className="page-text">
            <li>
              Confirmed that current cannabis cultivation processes are long and
              costly{" "}
            </li>
            <li>Provided initial information on current cannabis processes</li>
          </ul>
        </ReadAloud>
        <ReadAloud fontSize={`${16 + fontSize}px`}>
          <h4 style={{ fontSize: `${20 + fontSize}px` }} className="page-name">
            Kevin Chen | CEO at Hyasynth | Cannabinoid Industry Expert
          </h4>
          <ul className="page-text">
            <li>Provided specific feedback on our proposed implementation </li>
          </ul>
        </ReadAloud>
      </div>
    ),
    Sponsors: (
      <div>
        <img
          style={{ margin: `5%` }}
          width="40%"
          alt="citadel"
          src="https://static.igem.wiki/teams/4393/wiki/sponsors/2560px-citadel-llc-logo-svg.png"
        />
        <img
          style={{ margin: `5%` }}
          width="40%"
          alt="mathsoc"
          src="https://static.igem.wiki/teams/4393/wiki/sponsors/mathsoc-rgb-horizontalstandard.svg"
        />
        <div style={{ display: "flex", flexDirection: "row" }}>
          <img
            style={{ margin: `5%` }}
            width="40%"
            height="40%"
            alt="cbb"
            src="https://static.igem.wiki/teams/4393/wiki/sponsors/cbb-logo-rgb-tag-0.png"
          />
          <div style={{ display: "flex", flexDirection: "column" }}>
            <img
              style={{ margin: `5%` }}
              width="80%"
              alt="weef"
              src="https://static.igem.wiki/teams/4393/wiki/sponsors/weef-logo-yellow-0.png"
            />
            <img
              style={{ margin: `5%` }}
              width="80%"
              alt="mef"
              src="https://static.igem.wiki/teams/4393/wiki/sponsors/mef-final-logo.png"
            />
          </div>
        </div>
        <img
          style={{ margin: `5%` }}
          width="40%"
          alt="engsoc"
          src="https://static.igem.wiki/teams/4393/wiki/sponsors/logo-engsoc-0.png"
        />
        <img
          style={{ margin: `5%` }}
          width="40%"
          alt="outlined"
          src="https://static.igem.wiki/teams/4393/wiki/sponsors/outlined-logo-1613412659.png"
        />
        <div
          style={{
            fontSize: `${24 + fontSize}px`,
            marginBottom: "2vh",
            textAlign: "center",
            color: `var(--logo)`,
          }}
        >
          Mark Giesbrecht, University of Waterloo Dean of Mathematics
        </div>
        <div
          style={{
            fontSize: `${24 + fontSize}px`,
            marginBottom: "2vh",
            textAlign: "center",
            color: `var(--logo)`,
          }}
        >
          Bob Lemieux, University of Waterloo Dean of Science
        </div>
        <div
          style={{
            fontSize: `${24 + fontSize}px`,
            marginBottom: "2vh",
            textAlign: "center",
            color: `var(--logo)`,
          }}
        >
          Mary Wells, University of Waterloo Dean of Engineering
        </div>
      </div>
    ),
  };

  return (
    <div className="page">
      <h1 className="page-title">Attributions</h1>
      <div className="page-text">
        <ReadAloud fontSize={`${18 + fontSize}px`}>
          Pinene Express would not have been possible without the help of our
          team members, advisors, stakeholders, and sponsors!
        </ReadAloud>
      </div>
      <ButtonSection sections={sections} />
    </div>
  );
};

export default Attributions;
